<div
  id="activation-container"
  fxLayout="column"
  fxLayoutAlign="space-between stretch"
>
  <mat-toolbar>تایید شماره تلفن همراه</mat-toolbar>
  <div class="description">
    <div class="title" fxLayout="row" fxLayoutAlign="space-between center">
      <h4></h4>
    </div>
    <p class="description">
      کد موقت به شماره تلفن
      <strong class="phone-number">{{ userData.phone || "----------" }}</strong>
      ارسال شد
    </p>
  </div>

  <form
    [formGroup]="activationFormGroup"
    id="code-input"
    fxLayout="row"
    fxLayoutAlign="space-evenly center"
  >
    <input
      inputmode="numeric"
      (keyup)="onDigitInput($event)"
      [attr.rec]="cname"
      maxlength="1"
      *ngFor="let cname of formGroupKeys"
      [placeholder]="parseInt(cname)"
      type="text"
      [formControlName]="cname"
      [class]="cname + ' activation-input'"
    />
  </form>

  <div id="countDown">
    <span>زمان باقی مانده برای درخواست کد جدید : </span>
    <countdown
      (event)="onLimitOut($event)"
      #countDown
      [config]="countDownConfig"
    ></countdown>
  </div>

  <div class="actions">
    <button
      mat-button
      (click)="generateActivationCode()"
      color="warn"
      [disabled]="actionsDeactivated"
      #resendBtn
    >
      ارسال دوباره‌ی کد
    </button>
    <button
      [disabled]="actionsDeactivated"
      (click)="togglePhoneUpdate()"
      mat-flat-button
      color="primary"
    >
      تغییر شماره
    </button>
  </div>
</div>
